export const DEFAULT_LOCALHOST = 'http://localhost:5000'
export const IC_HOST = 'https://icp0.io'

export const PLUG_DOCS_URL = 'https://docs.plugwallet.ooo/'
export const PLUG_SUPPORT_URL = 'https://support.plugwallet.ooo/'
